import React, { Component } from 'react';
import { connect } from 'react-redux';
import Mixpanel from 'helpers/Mixpanel.js';
import PageHeader from 'components/Global/PageHeader/PageHeader.jsx';
import Box from '@bit/knotchinc.web-react-components.box';
import { Page, PageBody } from '@bit/knotchinc.web-react-components.page';
import Modal from '@bit/knotchinc.web-react-components.modal';
import Text from '@bit/knotchinc.web-react-components.text';
import { HEADER_TEXTS } from 'constants/tableConstants.js';
import { TableSync } from '@bit/knotchinc.web-react-components.table-sync';
import { fetchReportsList, SET_REPORTS_LIST_FILTER } from '../actions.js';
import { ReportRow } from './rows/ReportRow.jsx';
import ReportRequestGenerator from '../ReportRequestGenerator/ReportRequestGenerator.jsx';
// import { CreateButton } from '../styled.js';

class ReportListView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestModalOpen: false,
    };
  }

  componentDidMount() {
    Mixpanel.track('viewed Report List page');
  }

  render() {
    const { getReports, Reports: { reportsList }, isKnotchAdmin } = this.props;
    const { requestModalOpen } = this.state;
    const close = () => this.setState({ requestModalOpen: false });

    return (
      <Page>
        <Modal close={close} isOpen={requestModalOpen} title="Report Generator">
          <ReportRequestGenerator close={close} />
        </Modal>
        <PageHeader title={`Reports`} fetched />
        <PageBody maxWidth="1600px">
          <Box mb="32px">
            <Text fontSize="16px" lineHeight="22px" color="#323848" mb="20px">
              All Reports
            </Text>
            <Text fontSize="12px" color="#585858">
              Your next competitive content report will be generated for you on a weekly or monthly basis. Now, that's
              intelligence.
            </Text>
          </Box>
          {/* <CreateButton onClick={() => this.setState({ requestModalOpen: true })}>CREATE REPORT</CreateButton> */}
          <TableSync
            headerTexts={HEADER_TEXTS}
            tableStore={reportsList}
            fetch={(clear) => getReports(clear)}
            loadOnScroll
            actionType={SET_REPORTS_LIST_FILTER}
          >
            <ReportRow isKnotchAdmin={isKnotchAdmin} />
          </TableSync>
        </PageBody>
      </Page>
    );
  }
}


const mapStateToProps = ({
  Account: { isKnotchAdmin },
  Reports,
}) => ({ isKnotchAdmin, Reports });

const mapDispatchToProps = dispatch => ({
  getReports: clear => dispatch(fetchReportsList(clear)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportListView);
